import React from "react";
import { Row } from "antd";

import PageContainer from "../layout/PageContainer";
import styles from "./Login.module.css";

function Privacy() {
    return (
        <PageContainer pageBackground={`#fff`} contentPadding={16}>
            <Row className={styles.tos} align="middle" justify="center">
                <div className="container">
                    <section>
                        <p>
                            주식회사 루타스(이하 ‘회사’)는 개인정보 보호법 등 관련 법령상의 개인 정보 보호 규정을 준수하여 고객의 개인 정보 및 권익을
                            보호하고 개인 정보와 관련한 고객의 고충을 원활하게 처리할 수 있도록 다음과 같은 개인정보 처리방침을 두고 있습니다.
                        </p>
                    </section>
                    <section>
                        <h4>제 1 조 개인 정보의 처리 목적, 항목 및 보유기간</h4>
                        <p>
                            1. 회사는 다음의 목적을 위하여 아래와 같이 개인 정보 항목을 처리하고 있습니다. 법령에 따른 개인 정보 보유·이용 기간 또는
                            고객으로부터 개인 정보를 수집할 당시에 동의 받은 개인 정보 보유·이용 기간 내에서 개인 정보를 처리·보유합니다. 처리하고
                            있는 개인 정보를 다음의 목적 이외의 용도로는 이용하지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법 등 관련 법령에
                            따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
                        </p>
                        <table>
                            <thead>
                                <th>수집·이용 목적</th>
                                <th>수집 항목</th>
                                <th>보유 기간</th>
                            </thead>
                            <tbody>
                                <td>
                                    - 고객 본인 식별 및 본인 차량 여부 확인, 서비스(이하 “서비스”) 제공 및 서비스의 개선·개발
                                    <br />
                                    : 회원제 서비스의 본인 확인 및 본인 차량 여부 확인, 이동 통신망 개통, 서비스 제공, 기존 서비스·제품 개선 및 신규
                                    서비스·제품 개발, 서비스 목적의 안내 정보 전달, 상품 연구 개발, 긴급 출동 서비스, 서비스 품질 향상 및 고객 불만
                                    처리 등을 목적으로 개인 정보 처리
                                    <br />
                                    <br />
                                    - 서비스 관련 고지사항 전달·대금 납부 현황 확인 등 고객 관리
                                    <br />
                                    : 불량 회원의 부정 이용 방지와 비인가 사용 방지, 서비스에 대한 만족도 조사, 고객의 서비스 이용에 대한 통계, 가입
                                    이력 조회, 무료 기간 종료 후 유료 전환 동의 안내, 서비스·콘텐츠 구매 및 요금 결제, 물품 배송 또는 청구서 등 발송,
                                    금융 거래 본인 인증 및 금융 서비스, 대금 추심을 위한 본인 확인, 분쟁 조정을 위한 기록 보존, 불만 처리 등 민원
                                    처리, 고지 사항 전달, 요금 청구, 미납 요금의 회수, 채권 추심 등을 목적으로 개인 정보 처리
                                    <br />
                                    <br />
                                    - 마케팅 및 광고에 활용
                                    <br />: 이벤트 등 마케팅 및 전화, E-mail, SMS 등을 통한 광고성 정보 전달, 인구 통계학적 특성에 따른 서비스 제공 및
                                    광고 게재 등을 목적으로 개인 정보 처리
                                </td>
                                <td>
                                    [필수항목]
                                    <br />
                                    차량정보, 단말 장치 정보, 개인화 프로필, 가입자 정보, 차량 작동 정보, 차량 상태 정보, 사용 이력 정보, 개인
                                    위치정보
                                    <br />
                                    <br />
                                    [선택항목]
                                    <br />
                                    가입자 정보 (마케팅 등의 목적으로 활용시)
                                    <br />※ 상세 항목은 제7조. 처리하는 개인 정보 항목 및 수집 방법에서 확인하실 수 있습니다.
                                </td>
                                <td>
                                    서비스 제공 기간 및 서비스 해지 시점까지
                                    <br />
                                    ① 차량 작동/상태 정보, 사용 이력 정보, 진단 정보, 소모품 관리 정보 및 개인 위치 정보 수집·이용 목적 달성 시 또는
                                    동의 철회 시까지
                                    <br />
                                    ② 요금 결제 및 정산이 완료되지 않은 경우, 요금 결제 및 정산 완료 시까지
                                    <br />
                                    ③ 고객의 불만/민원 처리, 소송 등 분쟁이 진행 중이거나 예상되는 경우, 처리 완료 시까지
                                    <br />
                                    ④ 수집된 개인 정보의 마케팅 및 광고를 위한 이용은 서비스 해지 또는 동의 철회 시까지
                                    <br />
                                    ⑤ 길 안내, 안전 보안 등 개인 위치정보 활용 서비스 의 경우, 1개월
                                    <br />
                                    ⑥ 내 차 위치 공유 서비스는 고객 동의 시점으로부터 1시간
                                    <br />⑦ 개인화 프로필은 서비스 해지 후 6개월
                                </td>
                            </tbody>
                        </table>
                        <p>
                            2. 단, 다음에 해당하는 경우에는 각 법률 규정에서 정한 기간 동안 개인 정보를 보유하며, 아래 열거된 법률 외에 다른 법령상
                            보존 의무를 부담하는 경우에도 해당 법령상 의무 이행을 위한 범위 내에서 개인 정보를 보유합니다.
                        </p>
                        <p>
                            ① 「전자상거래 등에서의 소비자 보호에 관한 법률」에 따른 계약 내용 및 이행 등 거래에 관한 기록
                            <br />
                            1) 계약 또는 청약 철회 등에 관한 기록 : 5년
                            <br />
                            2) 대금 결제 및 재화 등의 공급에 관한 기록 : 5년
                            <br />
                            3) 소비자의 불만 또는 분쟁 처리에 관한 기록 : 3년
                            <br />② 「상법」에 따른 회사의 상업 장부와 영업에 관한 중요 서류 및 전표 등에 관련된 정보 <br /> 1) 상업장부 및 영업에
                            관한 중요서류 : 10년 <br /> 2) 전표 또는 이와 유사한 서류: 5년 <br /> ③ 「국세기본법」, 「법인세법」에 따른 모든 거래에
                            관한 장부 및 증빙 서류와 관련된 정보 : 그 거래 사실이 속하는 과세 기간에 대한 해당 국세의 법정 신고 기한이 지난 날부터 5년
                            <br />④ 「부가가치세법」에 따른 장부와 교부한 세금 계산서 또는 영수증 : 5년 <br />
                            ⑤「신용정보의 이용 및 보호에 관한 법률」에 따른 신용 정보의 수집·처리 및 이용 등에 관한 기록 : 3년
                        </p>
                        <p>
                            3. 회사는 개인위치정보의 수집 사실 확인 자료를 「위치정보의 보호 및 이용 등에 관한 법률」 제16조 제2항에 근거하여 위치정보
                            시스템에 자동으로 기록하며, 민원 처리 등을 위하여 개인위치정보 수집사실 확인 자료를 그 기록 시점으로부터 6개월 동안
                            보유합니다.
                        </p>
                    </section>
                    <section>
                        <h4>제 2 조 고객의 정의</h4>
                        <p>1. 고객은 서비스에 가입한 자로서 아래와 같이 구분됩니다.</p>
                        <p>
                            ① 정회원 : 서비스에 가입한 차량(이하 ‘가입 차량’)의 소유자 또는 소유자로부터 정회원 자격 취득의 허락을 받고 회사가 정하는
                            방법으로 이를 증명한 자(법인 및 개인)
                            <br />
                            ② 실사용 회원 : 서비스에 가입한 차량의 소유자가 법인인 경우, 정회원으로부터 임대·대여 등을 통해 서비스의 이용 권한 및 다른
                            사람에게 차량을 공유할 수 있는 권한을 부여 받아 가입 차량에 대해 최초로 회사가 정하는 절차에 따라 모바일 앱을 통한 서비스
                            사용 권한을 획득한 자<br />
                            ③ 준회원 : 서비스 가입자 중 정회원과 실사용 회원을 제외한 자로서 회사가 정하는 절차에 따라 정회원 또는 실사용 회원으로부터
                            차량 공유를 승인 받은 자<br />※ 서비스 사용 권한 공유는 루타스 계정 (이하 ‘계정’)으로 가입한 고객의 경우에만 가능합니다.
                        </p>
                        <p>
                            2. 정회원 또는 실사용 회원의 승인을 받아 특정 차량의 서비스 사용 권한을 공유받은 준회원은 정회원과 동일한 서비스를
                            제공받으므로 이를 원하지 않는 경우, 정회원은 언제든지 모바일 앱을 통하여 차량 공유를 해제할 수 있습니다.
                        </p>
                    </section>
                    <section>
                        <h4>제 3 조 개인 정보 제3자 제공에 관한 사항</h4>
                        <p>
                            1. 회사는 원칙적으로 고객의 개인 정보를 수집·이용 목적으로 명시한 범위 내에서 처리하며, 고객의 동의, 법률의 특별한 규정이
                            있는 경우에만 개인 정보를 제3자에게 제공합니다. 단, 회사는 다음의 경우에는 고객의 동의를 받지 않고 그 개인 정보를
                            제3자에게 제공할 수 있습니다.
                        </p>
                        <p>
                            ① 정보 통신 서비스의 제공에 따른 요금 정산을 위하여 필요한 경우
                            <br />② 정보통신망 이용촉진 및 정보보호 등에 관한 법률 또는 다른 법률에 특별한 규정이 있는 경우
                        </p>
                        <p>2. 회사는 서비스 제공을 위하여 다음과 같이 개인 정보를 제3자에게 제공하고 있습니다.</p>
                        <table>
                            <thead>
                                <th>제공받는 자</th>
                                <th>제공받는 자의 이용 목적</th>
                                <th>제공하는 항목</th>
                                <th>제공받는 자의 보유 및 이용 기간</th>
                            </thead>
                            <tbody>
                                <tr>
                                    <th>금융결제원</th>
                                    <td>CMS 출금 이체 서비스 제공 및 출금 동의 확인, 출금 이체 신규 등록 및 해지 사실 통지</td>
                                    <td>성명, 금융 기관명, 계좌 번호, 생년월일, 전화번호, (은행 등 금융 회사 및 이용 기관 보유) 휴대폰 번호</td>
                                    <td>CMS 출금 이체 서비스 제공 및 출금 동의 확인 목적을 달성할 때까지</td>
                                </tr>
                                <tr>
                                    <th>동일 차량을 함께 사용하는 준회원</th>
                                    <td>서비스 사용 환경 확인</td>
                                    <td>차종, 단말 번호</td>
                                    <td>차량을 공유하는 기간 동안</td>
                                </tr>
                                <tr>
                                    <th>동일 차량을 함께 사용하는 정회원 또는 실사용 회원</th>
                                    <td>동일 차량 사용자 관리</td>
                                    <td>준회원의 이름, 준회원의 휴대전화번호, 준회원의 계정 ID</td>
                                    <td>차량을 공유하는 기간 동안</td>
                                </tr>
                                <tr>
                                    <th>RUTA40 차량 관제 시스템 또는 RUTA40 플랫폼 이용 고객이 지정하는 제3자</th>
                                    <td>RUTA40 차량 관제 시스템 또는 RUTA40 플랫폼 내 차량 운행 현황 및 차량 관리를 위함</td>
                                    <td>개인 위치 정보, DTG 데이터, 충전 내역, 차량 진단 정보, 차량 작동 정보</td>
                                    <td>서비스 해지 시까지(단, DTG 데이터는 6개월간 보관하며, 서비스 해지 시에는 즉시 삭제)</td>
                                </tr>
                            </tbody>
                        </table>
                        <p>
                            단, RUTA40 차량 관제 서비스와 관련하여 당사가 운전자를 특정할 수 없는 경우, RUTA40 플랫폼을 이용하는 가입자는 운전자의
                            개인 정보 및 위치 정보 수집에 대해 가입자의 책임 하에 수집·동의를 받아야 하며, 동의 없이 위치 정보를 수집·이용하여
                            발생하는 문제에 대해서는 회사가 책임지지 않습니다.
                        </p>
                        <p>
                            3. 회사는 고객님의 개인위치정보를 고객님께서 지정하는 제3자에게 제공하는 경우 개인위치정보를 수집한 당해 통신 단말 장치로
                            매회 고객님께 제공받는 자, 제공 일시 및 제공 목적을 즉시 통보합니다. 단, 다음에 해당하는 경우에는 고객님께서 미리 특정하여
                            지정한 통신 단말 장치 또는 E-mail로 통보합니다.
                        </p>
                        <p>
                            - 개인위치정보를 수집한 당해 통신 단말 장치가 문자, 음성 또는 영상의 수신 기능을 갖추지 않은 경우
                            <br />
                            - 개인위치정보 주체가 개인위치정보를 수집한 당해 통신 단말 장치 외의 통신 단말 장치 또는 E-mail 등으로 통보할 것을 미리
                            요청한 경우
                            <br />
                            ※ 단, 최대 30일의 범위에서 다음 각 사항에 따라 정보제공내역을 모아서 통보할 수 있습니다.
                            <br />- 횟수: 10회, 20회, 또는 30회 등 10배수의 횟수 - 기간: 10일, 20일 또는 30일
                        </p>
                    </section>
                    <section>
                        <h4>제 4 조 고객의 권리·의무 및 행사 방법</h4>
                        <p>1. 고객은 회사에 대해 언제든지 다음 각 호의 개인 정보 보호 관련 권리를 행사할 수 있습니다.</p>
                        <p>
                            ① 개인 정보 열람 요구
                            <br />
                            ② 오류 등이 있을 경우, 정정 요구
                            <br />
                            ③ 삭제 요구
                            <br />④ 처리 정지 요구
                        </p>
                        <p>
                            2. 제1항에 따른 권리 행사는 주식회사 루타스 고객센터(070-7707-1768)로 전화 기타 회사가 제공하는 방법을 통하여 하실 수
                            있으며 회사는 이에 대해 지체 없이 조치하겠습니다.
                        </p>
                        <p>
                            3. 고객이 개인 정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 회사는 정정 또는 삭제를 완료할 때까지 당해 개인
                            정보를 이용하거나 제공하지 않습니다. 또한, 잘못된 개인 정보를 제3자에게 이미 제공한 경우에는 제3자 및 당사자에게 그 사실을
                            통지하여 필요한 조치를 취합니다.
                        </p>
                        <p>
                            4. 고객이 본인의 개인 정보에 대한 제1항에 따른 권리 행사를 요구하는 경우, 회사는 고객의 신분을 나타내는 주민 등록증, 여권,
                            운전 면허증(신형) 등의 신분 증명서를 제시 받는 등의 방법으로 본인 여부를 확인합니다.
                        </p>
                        <p>
                            5. 제1항에 따른 권리 행사는 고객의 법정 대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우, 회사는 그
                            대리인에게 대리 관계를 나타내는 위임장 및 명의 고객의 인감 증명서와 대리인의 신분 증명서 등의 증표를 제시 받는 등의
                            방법으로 진정한 대리인인지 여부를 확인합니다.
                        </p>
                        <p>6. 회사는 제1항에 따른 권리 행사를 거절할 정당한 이유가 있는 경우에는 고객에게 이를 통지하고 그 이유를 설명합니다.</p>
                    </section>
                    <section>
                        <h4>제 5 조 처리하는 개인 정보 항목 및 수집 방법</h4>
                        <p>
                            ① 필수 항목
                            <br /> 1) 차량 정보 : 차량 계약번호, 차종, 차대번호
                            <br />
                            2) 단말 장치 정보 : FMU 단말 장치 모델코드, FMU 단말 장치 일련번호, USIM 모델 코드, USIM 일련번호
                            <br />
                            3) 개인화 프로필 : 고객이 차량, 인포테인먼트 시스템 및 서비스에서 설정/사용한 값에 관한 정보
                            <br />
                            4) 가입자 정보 : 성명, 생년월일, 성별, 전화번호, E-mail, 비밀번호, 계정 생성 여부, 계정 ID(휴대전화번호), SNS 종류,
                            계정상태
                            <br />
                            ※ SNS 종류는 계정 생성 시 SNS ID로 가입한 경우에만 수집됩니다.
                            <br />
                            5) 응급 구호 정보 : 긴급 연락처, 차량 번호
                            <br />
                            6) 납부 정보 : 납부인명, 납부인 생년월일, 성별, 사업자 번호, 계좌/카드 번호, 은행(카드)명, 카드 유효 기간, 수취인명, 청구
                            E-mail, 청구 주소, 납부 여부 및 납부 내역 등<br />
                            7) 대리인 정보 : 성명, 생년월일, 성별, 전화번호, 가입자와의 관계
                            <br />
                            8) 차량 작동 정보 : GPS 정보, 운행 일자, 운행 시작, 운행 종료, 운행 거리, 평균속도, 잔여 soc, 배터리 사용량, 배터리 상태,
                            충전 여부 등 차량의 작동에 관한 정보
                            <br />
                            9) 차량 상태 정보 : 도어 잠금 상태, 디지털 키 수집 항목, 배터리, 디지털 키 발급 상태, 디지털 키 정보, 기타 차량의 상태에
                            관한 정보
                            <br />
                            10) 사용 정보 : 원격 제어 사용 이력, 디지털 키 사용 이력, 충돌 데이터 및 에러 로그 등 인포테인먼트 서비스 사용 이력과
                            관련한 정보
                            <br />
                            11) 진단 정보 : 고장 코드, 고장 발생 시 위치 정보, 누적 주행 거리, 서비스 데이터 등<br />
                            ② 선택 항목
                            <br />
                            - 가입자 정보 : (마케팅 등의 목적으로 활용 시)성명, 전화번호, E-mail
                            <br />※ 차량 작동 정보, 진단 정보는 차량에 따라 수집 정보에 차이가 있을 수 있으며, 서비스 개선에 따라 차량 작동/상태 정보,
                            사용 이력 정보, 진단 정보, 소모품 관리 정보의 세부 항목이 변경될 수 있습니다.
                        </p>
                        <p>2. 회사는 실사용 회원과 관련하여 다음의 개인 정보 항목을 처리하고 있습니다</p>
                        <p>
                            ① 필수 항목
                            <br /> 1) 가입자 정보 : 성명, 생년월일, 계정 ID(휴대전화번호), SNS 종류, 계정 상태
                            <br />
                            ※ SNS 종류는 계정 생성 시 SNS ID로 가입한 경우에만 수집됩니다.
                            <br />
                            2) 개인화 프로필 : 고객이 차량, 인포테인먼트 시스템 및 서비스에서 설정/사용한 값에 관한 정보
                            <br />
                            3) 차량 작동 정보 : GPS 정보, 운행 일자, 운행 시작, 운행 종료, 운행 거리, 평균속도, 잔여 soc, 배터리 사용량, 배터리 상태,
                            충전 여부 등 차량의 작동에 관한 정보
                            <br />
                            4) 차량 상태 정보 : 도어 잠금 상태, 디지털 키 수집 항목, 배터리, 디지털 키 발급 상태, 디지털 키 정보, 기타 차량의 상태에
                            관한 정보
                            <br />
                            5) 사용 정보 : 원격 제어 사용 이력, 디지털 키 사용 이력, 충돌 데이터 및 에러 로그 등 인포테인먼트 서비스 사용 이력과
                            관련한 정보
                            <br />
                            6) 진단 정보 : 고장 코드, 고장 발생 시 위치 정보, 누적 주행 거리, 서비스 데이터 등
                        </p>
                        <p>3. 회사는 아래와 같은 준회원의 개인 정보 항목을 처리하고 있습니다.</p>
                        <p>
                            ① 필수 항목
                            <br />
                            1) 가입자 정보 : 성명, 생년월일, 계정 ID(휴대전화번호), SNS 종류, 계정 상태
                            <br />
                            ※ SNS 종류는 계정 생성 시 SNS ID로 가입한 경우에만 수집됩니다.
                            <br />
                            2) 개인화 프로필 : 고객이 차량, 인포테인먼트 시스템 및 서비스에서 설정/사용한 값에 관한 정보
                            <br />
                            3) 차량 작동 정보 : GPS 정보, 운행 일자, 운행 시작, 운행 종료, 운행 거리, 평균속도, 잔여 soc, 배터리 사용량, 배터리 상태,
                            충전 여부 등 차량의 작동에 관한 정보
                            <br />
                            4) 차량 상태 정보 : 도어 잠금 상태, 디지털 키 수집 항목, 배터리, 디지털 키 발급 상태, 디지털 키 정보, 기타 차량의 상태에
                            관한 정보
                            <br />
                            5) 사용 정보 : 원격 제어 사용 이력, 디지털 키 사용 이력, 충돌 데이터 및 에러 로그 등 인포테인먼트 서비스 사용 이력과
                            관련한 정보
                            <br />
                            6) 진단 정보 : 고장 코드, 고장 발생 시 위치 정보, 누적 주행 거리, 서비스 데이터 등
                        </p>
                        <p>4. 회사가 개인 정보를 수집하는 방법은 다음과 같습니다.</p>
                        <p>
                            ① 회원 가입 및 서비스 이용 과정에서 고객의 동의를 얻어 수집
                            <br />
                            <br />
                            ② 고객 센터를 통한 상담 과정에서 웹 사이트, E-mail, 팩스, 전화 등을 통해 수집
                            <br />
                            ③ 이벤트 및 경품 행사 응모 과정에서 고객의 동의를 얻어 수집(회사는 이벤트 및 추가적인 개인 정보 수집 시, 수집 항목에 대한
                            필수·선택 동의 항목을 구분하며, 해당 페이지 및 서면 등에서 개인 정보의 수집 목적, 항목, 보유 기간 등을 고객에게 고지하고
                            추가적인 동의를 받습니다.)
                            <br />④ 고객의 요청에 의해 가입 후 개통 및 서비스 활성화 된 차량 단말 장치를 통해 수집
                        </p>
                    </section>
                    <section>
                        <h4>제 6 조 개인정보의 파기</h4>
                        <p>
                            1. 회사는 개인 정보 보유 기간의 경과, 처리 목적 달성 등 개인 정보가 불필요하게 되었을 때에는 지체 없이 해당 개인 정보를
                            파기합니다.
                        </p>
                        <p>
                            2. 회사는 위치정보의 보호 및 이용 등에 관한 법률 제24조 제4항의 규정에 의하여 고객님이 동의의 전부 또는 일부를 철회한
                            경우에는 지체 없이 수집된 개인위치정보 및 개인위치정보 수집사실 확인 자료(동의의 일부를 철회하는 경우에는 철회하는 부분의
                            개인위치정보 및 개인위치정보의 수집사실 확인 자료에 한함)를 파기합니다. 다만, 진행 중이거나 예상되는 고객의 불만/분쟁 처리
                            또는 국세기본법, 법인세법, 부가가치세법 기타 관계 법령의 규정에 의하여 보존할 필요성이 있는 경우에는 관계 법령에 의거
                            보존합니다.
                        </p>
                        <p>
                            3. 회사는 고객으로부터 동의 받은 개인 정보 보유 기간이 경과하거나 처리 목적이 달성되었음에도 불구하고 다른 법령에 따라
                            개인 정보를 계속 보존하여야 하는 경우에는, 해당 개인 정보를 별도의 데이터 베이스(DB)로 옮기거나 보관 장소를 달리하여
                            보존합니다.
                        </p>
                        <p>4. 개인 정보 파기의 절차 및 방법은 다음과 같습니다.</p>
                        <p>
                            ① 파기 절차 회사는 파기 사유가 발생한 개인 정보를 선정하고, 회사의 개인 (위치)정보 보호 책임자의 승인을 받아 개인 정보를
                            파기합니다.
                            <br />② 파기 방법 회사는 전자적 파일 형태로 기록·저장된 개인 정보는 기록을 재생할 수 없도록 파기하며, 종이 문서에
                            기록·저장된 개인 정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.
                        </p>
                    </section>
                    <section>
                        <h4>제 7 조 개인정보의 안정성 확보 조치</h4>
                        <p>회사는 개인 정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
                        <p>
                            ① 정기적인 자체 감사 실시
                            <br />
                            개인정보 취급 관련 안정성 확보를 위해 정기적으로 자체 감사를 실시하고 있습니다.
                            <br />
                            ② 개인정보 취급 직원의 최소화 및 교육
                            <br />
                            개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화 하여 개인정보를 관리하는 대책을 시행하고 있습니다.
                            <br />
                            ③ 내부관리계획의 수립 및 시행
                            <br />
                            개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.
                            <br />
                            ④ 해킹 등에 대비한 기술적 대책
                            <br />
                            회사는 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신•점검을
                            하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적 • 물리적으로 감시 및 차단하고 있습니다.
                            <br />
                            ⑤ 개인정보의 암호화
                            <br />
                            이용자의 개인정보는 암호화 되어 저장 및 관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화
                            하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.
                            <br />
                            ⑥ 접속기록의 보관 및 위변조 방지
                            <br />
                            개인정보처리시스템에 접속한 기록을 관계법령에서 요구하는 기간동안 보관, 관리하고 있으며, 접속 기록이 위변조 및 도난,
                            분실되지 않도록 보안기능을 사용하고 있습니다.
                            <br />
                            ⑦ 개인정보처리시스템 접근 제한
                            <br />
                            개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여, 변경, 말소를 통하여 개인정보에 대한 접근통제를 위하여
                            필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.
                            <br />
                            ⑧ 문서보안을 위한 잠금장치 사용
                            <br />
                            개인정보가 포함된 서류, 보조저장매체 등을 잠금장치가 있는 안전한 장소에 보관하고 있습니다.
                            <br />
                            ⑨ 비인가자에 대한 출입 통제
                            <br />
                            개인정보를 보관하고 있는 물리적 보관 장소를 별도로 두고 이에 대해 출입통제 절차를 수립, 운영하고 있습니다.
                        </p>
                    </section>
                    <section>
                        <h4>제 8조 개인정보를 자동으로 수집하는 장치의 설치·운영 및 그 거부에 관한 사</h4>
                        <p>
                            회사는 고객의 정보를 수시로 저장하고 찾아내는 ‘쿠키(cookie)’ 등을 운용합니다. 쿠키란 회사의 웹 사이트를 운영하는데
                            이용되는 서버가 고객의 브라우저에 보내는 아주 작은 텍스트 파일로서 고객의 컴퓨터 하드 디스크에 저장됩니다. 회사는 다음과
                            같은 목적을 위해 쿠키를 사용합니다.
                        </p>
                        <p>
                            1. 쿠키 등 사용 목적 홈페이지 접속 빈도 및 방문 시간 분석, 고객의 관심 분야 파악 및 분석, 각종 이벤트 참여 및 방문 횟수
                            파악 등을 통한 타겟 마케팅 및 개인 맞춤 서비스 제공을 위해 쿠키 등을 사용합니다. 고객은 쿠키 설치에 대한 선택권을 가지고
                            있습니다. 따라서, 고객은 웹 브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나,
                            아니면 모든 쿠키의 저장을 거부할 수도 있습니다.
                        </p>
                        <p>
                            2. 쿠키 설정 거부 방법 쿠키 설정을 거부하는 방법으로는 고객이 사용하는 웹 브라우저의 옵션을 선택함으로써 모든 쿠키를
                            허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다. 다만, 쿠키의 저장을 거부할
                            경우에는 로그인이 필요한 일부 서비스는 이용에 어려움이 있을 수 있습니다.
                        </p>
                        <p>※ 설정 방법 예(인터넷 익스플로어의 경우) : 웹 브라우저 상단의 도구 → 인터넷 옵션 → 개인 정보 → 고급 → 설정 방법 선택</p>
                    </section>
                    <section>
                        <h4>제 9 조 개인정보 보호 책임자</h4>
                        <p>
                            회사는 개인 정보 처리에 관한 업무를 총괄해서 책임지고, 개인 정보 처리와 관련한 정보 주체의 불만 처리 및 피해 구제 등을
                            위하여 아래와 같이 개인 정보 보호 책임자를 지정하고 있습니다.
                        </p>
                        <table>
                            <thead>
                                <th colSpan={2}>개인정보보호 정책 및 총괄</th>
                            </thead>
                            <tbody>
                                <tr>
                                    <th>
                                        - 개인정보 보호책임자 <br />: 정욱수 이사
                                        <br />- 소속 : 연구소
                                    </th>
                                    <td>
                                        - 개인 (위치)정보 보호 담당자 : 정욱수
                                        <br />
                                        - 소속부서 : 경영관리팀
                                        <br />
                                        - 전화번호 : 010-2680-0510
                                        <br />- 이메일 : yeati809@naver.com
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p>
                            2. 고객은 회사의 서비스(또는 사업)를 이용하면서 발생한 모든 개인 정보 보호 관련 문의, 불만 처리, 피해 구제 등에 관한
                            사항을 개인 정보 보호 책임자 및 담당 부서에 문의할 수 있습니다. 회사는 고객의 문의에 대해 지체 없이 답변 및 처리할
                            것입니다.
                        </p>
                    </section>
                    <section>
                        <h4>제 10 조 개인 정보의 열람·정정·삭제·처리 정지 등 청구</h4>
                        <p>
                            1. 고객은 개인정보의 열람·정정·삭제·처리 정지 등 청구를 제12조. 개인 정보 보호 책임자에 관한 사항의 개인 정보 보호 담당
                            부서에 할 수 있습니다. 회사는 정보 주체의 개인 정보 열람·정정·삭제·처리 정지 등 청구가 신속하게 처리되도록 노력하겠습니다.
                        </p>
                        <p>
                            2. 준회원의 개인 정보 열람·정정·삭제·처리 정지 등 청구로 인하여 정회원 또는 실사용 회원과 공동으로 사용하는 서비스의
                            품질이 저해되거나, 정회원의 원활한 서비스 이용에 지장이 생길 우려가 있는 경우, 회사는 준회원의 청구를 거부하거나, 청구에
                            대한 정회원 또는 실사용 회원의 동의를 요구하는 등 적절한 제한을 가할 수 있습니다.
                        </p>
                        <p>
                            3. 고객이 동일한 차량 및 단말 장치를 이용하면서 서비스를 공동으로 사용하고, 경우에 따라서는 제3자 또한 서비스를 이용할 수
                            있으므로, 단말 장치를 통하여 수집되는 운행 정보 또는 위치 정보가 정회원, 실사용 회원, 준회원 또는 제3자의 것인지 여부를
                            명확하게 구별하기 어려울 수 있습니다.
                        </p>
                        <p>
                            4. 단말 장치를 통하여 수집되는 개인 정보의 내용이 실제 정회원, 실사용 회원, 그리고 준회원 자신의 정보와 일치하지 않을 수
                            있고, 이로 인하여 부득이 열람 등 요청에 대하여 정확하지 않은 정보가 전달될 수 있습니다.
                        </p>
                        <p>
                            5. 제3항에 기재된 사유로 회사는 서비스의 원활한 제공을 위하여 수집·생성된 정보는 단말 장치에서 선택한 운전자를 기준으로
                            추정하며, 운전자 선택이 없는 경우에는 정회원의 정보로 추정합니다.
                        </p>
                        <p>
                            6. 제5항에도 불구하고 고객은 자신의 정보에 대한 권리 행사를 하기 위해서 해당 정보가 준회원 본인의 정보라는 점을 직접
                            소명해야 합니다.
                        </p>
                        <p>
                            7. 가입 차량 및 단말 장치를 통해 수집·생성된 운행 정보가 누적되어 발생되는 정보와 누적된 정보를 바탕으로 분석하여 발생되는
                            통계 정보들은 운행 정보를 생성한 모든 가입자의 정보로 보며 모든 가입자가 이 정보에 대한 권리 행사가 가능합니다. 단, 본 조
                            2항에 의거하여 이러한 누적·통계 정보들에 대한 준회원의 열람·정정·삭제·처리 정지 등 청구로 인하여 정회원 또는 실사용 회원과
                            공동으로 사용하는 서비스의 품질이 저해되거나, 정회원의 원활한 서비스 이용에 지장이 생길 우려가 있는 경우, 회사는 준회원의
                            청구를 거부하거나, 청구에 대한 정회원 또는 실사용 회원의 동의를 요구하는 등 적절한 제한을 가할 수 있습니다.
                        </p>
                    </section>
                    <section>
                        <h4>제 11 조 권익 침해 구제 방법</h4>
                        <p>고객은 아래의 기관에 개인 정보 침해에 대한 피해 구제, 상담 등을 문의하실 수 있습니다.</p>
                        <p>1. 개인정보침해 신고센터 (한국인터넷진흥원 운영)</p>
                        <p>
                            ① 소관 업무 : 개인 정보 침해 사실 신고, 상담 신청
                            <br />
                            ② 홈페이지 : privacy.kisa.or.kr
                            <br />
                            ③ 전화 : (국번없이) 118
                            <br />④ 주소 : 전라남도 나주시 진흥길 9 한국인터넷진흥원
                        </p>
                        <p>2. 개인정보 분쟁조정위원회</p>
                        <p>
                            ① 소관업무 : 개인 정보 분쟁 조정 신청, 집단 분쟁 조정 (민사적 해결) ② 홈페이지 : www.kopico.go.kr
                            <br />
                            ③ 전화 : 1833-6972
                            <br />④ 주소 : 서울특별시 종로구 세종대로 209 정부서울청사 4층
                        </p>
                        <p>
                            3. 대검찰청 사이버범죄수사단 : (국번없이) 1301
                            <br />
                            cid@spo.go.kr (www.spo.go.kr)
                        </p>
                        <p>
                            4. 경찰청 사이버안전국 : (국번없이) 182
                            <br />
                            (cyberbureau.police.go.kr)
                        </p>
                    </section>
                    <section>
                        <h4>제 12 조 개인정보 처리방침 변경</h4>
                        <p>이 개인정보처리방침은 2025년 5월 25일부터 적용됩니다.</p>
                    </section>
                </div>
            </Row>
        </PageContainer>
    );
}

export default Privacy;
